import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';

export default class SwitchField extends React.Component {
    render() {
        const {
            id,
            title,
            placeholder,
            error,
            errorText,
            helperText,
            required,
            disabled,
            inputValue,
            onBlur,
            onFocus,
            uiSchema,
            formControlComponent
        } = this.props;

        const inputValueBoolean = inputValue === true;

        const { classes = {} } = uiSchema;
        const onChange = ({ target: { value } }) => {
            const valueBooleanInversed = value === 'false';

            this.props.onChange(id, valueBooleanInversed);
        };

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component={ formControlComponent }
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    { title ? <FormLabel
                        component="legend"
                        classes={{
                            root: classes.titleContainer
                        }}
                    >{ title }</FormLabel> : null }
                    <FormControlLabel
                        classes={{
                            root: classes.formControlLabel || '',
                            label: classes.label || ''
                        }}
                        control={
                            <Switch
                                id={id}
                                classes={{
                                    root: classes.switch || '',
                                    checked: classes.checked || '',
                                    disabled: classes.disabled || '',
                                    track: classes.track || ''
                                }}
                                disabled={ disabled }
                                checked={ inputValueBoolean }
                                onChange={ onChange }
                                value={ inputValueBoolean }
                                onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                                onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                            />
                        }
                        label={ placeholder }
                    />
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

SwitchField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({

    }),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string,
            formControlLabel: PropTypes.string,
            switch: PropTypes.string,
            disabled: PropTypes.string,
            checked: PropTypes.string,
            track: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    formControlComponent: PropTypes.string
};

SwitchField.defaultProps = {
    title: '',
    emptyValue: false,
    placeholder: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {},
    uiSchema: {},
    inputValue: '',
    helperText: '',
    formControlComponent: 'fieldset'
};
